var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgServersideIconHelp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "12.44 12 26.3 26.3",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HILFSLINIEN"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_UMGEWANDELT"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6282B3",
    d: "M25.576,12c-7.237,0-13.125,5.888-13.125,13.125S18.339,38.25,25.576,38.25s13.125-5.888,13.125-13.125 S32.813,12,25.576,12z M25.576,37c-6.548,0-11.875-5.327-11.875-11.875S19.028,13.25,25.576,13.25s11.875,5.327,11.875,11.875 S32.124,37,25.576,37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6282B3",
    d: "M24.652,30.262c-0.169,0.185-0.255,0.412-0.255,0.676c0,0.26,0.087,0.482,0.258,0.66 c0.173,0.185,0.412,0.277,0.711,0.277c0.29,0,0.527-0.092,0.706-0.271c0.18-0.18,0.271-0.403,0.271-0.666 c0-0.267-0.09-0.495-0.266-0.679C25.715,29.877,24.989,29.89,24.652,30.262z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6282B3",
    d: "M25.629,18.375c-1.04,0-1.912,0.312-2.595,0.927c-0.541,0.49-0.878,1.115-1,1.857 c-0.036,0.214,0.025,0.434,0.168,0.602c0.148,0.176,0.365,0.276,0.598,0.276c0.373,0,0.693-0.275,0.76-0.654 c0.074-0.425,0.252-0.764,0.545-1.037c0.385-0.358,0.884-0.533,1.524-0.533c0.629,0,1.101,0.179,1.442,0.546 c0.346,0.373,0.515,0.88,0.515,1.549c0,0.335-0.042,0.636-0.124,0.892c-0.084,0.264-0.199,0.496-0.353,0.711 c-0.152,0.219-0.519,0.613-1.086,1.173c-0.609,0.599-0.997,1.111-1.186,1.566c-0.134,0.321-0.225,0.714-0.269,1.167 c-0.021,0.213,0.051,0.427,0.196,0.586c0.146,0.162,0.355,0.255,0.573,0.255c0.395,0,0.723-0.299,0.764-0.694 c0.079-0.768,0.367-1.35,0.887-1.787c0.817-0.751,1.383-1.423,1.682-1.998c0.304-0.586,0.458-1.221,0.458-1.888 c0-1.066-0.317-1.929-0.943-2.561C27.558,18.696,26.697,18.375,25.629,18.375z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS_PFADE",
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#6282B3",
    strokeWidth: 1.25,
    cx: 25.576,
    cy: 25.125,
    r: 12.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6282B3",
    stroke: "#6282B3",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M25.339,28.007 c-0.305,0-0.549-0.263-0.52-0.566c0.042-0.433,0.125-0.799,0.249-1.096c0.175-0.42,0.552-0.915,1.13-1.483 c0.578-0.569,0.951-0.971,1.116-1.208c0.167-0.237,0.295-0.495,0.385-0.779s0.136-0.605,0.136-0.968 c0-0.729-0.195-1.301-0.582-1.719c-0.389-0.418-0.931-0.626-1.625-0.626c-0.701,0-1.265,0.201-1.696,0.601 c-0.33,0.308-0.537,0.7-0.62,1.177c-0.044,0.255-0.255,0.448-0.514,0.448h-0.003c-0.314,0-0.568-0.278-0.517-0.588 c0.114-0.689,0.422-1.259,0.922-1.712c0.637-0.574,1.445-0.862,2.427-0.862c1.004,0,1.797,0.293,2.379,0.88 c0.58,0.586,0.871,1.381,0.871,2.385c0,0.63-0.143,1.221-0.429,1.772c-0.286,0.551-0.829,1.194-1.629,1.929 c-0.558,0.469-0.88,1.118-0.966,1.946C25.826,27.803,25.606,28.007,25.339,28.007L25.339,28.007z M24.648,30.938 c0-0.201,0.062-0.369,0.189-0.507c0.125-0.138,0.302-0.207,0.529-0.207c0.222,0,0.399,0.069,0.53,0.207 c0.132,0.138,0.198,0.307,0.198,0.507c0,0.194-0.065,0.356-0.198,0.489c-0.13,0.132-0.308,0.199-0.53,0.199 c-0.228,0-0.405-0.066-0.529-0.199C24.71,31.294,24.648,31.132,24.648,30.938z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "BESCHRIFTUNG"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgServersideIconHelp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/serverside-icon-help.e1f92c6a.svg";
export { ForwardRef as ReactComponent };